import React from "react"

import ObservationKeyMarker from "../../GraphKeys/ObservationKeyMarker"
import { withFontSizeConfig } from "../../../../config/FontSizeConfigProvider"

function SeriesKey({
  download,
  liveView,
  labelFontSize, // From FontSizeConfigProvider
  width = 250,
  spacing = 20,
  series = [],
}) {
  return (
    <div>
      {download || liveView ? (
        <div style={{ display: "table", margin: "0 auto" }}>
          {series.map((s, idx) => {
            return (
              <div
                key={idx}
                className={"flex-r"}
                style={{
                  float: "left",
                  marginRight: "15px",
                  alignItems: "center",
                }}
              >
                <svg width={20} height={spacing}>
                  <g transform={`translate(10, ${spacing / 2})`}>
                    <ObservationKeyMarker {...s} />
                  </g>
                </svg>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div style={{ fontSize: `${labelFontSize}px` }}>{s.label}</div>
                </div>
              </div>
            )
          })}
        </div>
      ) : (
        <svg width={width} height={series.length * spacing}>
          {series.map((s, idx) => (
            <g key={idx} transform={`translate(0, ${idx * spacing})`}>
              <g transform={`translate(10, ${spacing / 2})`}>
                <ObservationKeyMarker {...s} />
              </g>
              <text x={20} y={spacing * 0.75} fill="black" stroke="none" fontSize={labelFontSize}>
                {s.label}
              </text>
            </g>
          ))}
        </svg>
      )}
    </div>
  )
}

export default withFontSizeConfig(SeriesKey)
